@if (initialized && objectIdentifier) {

    <div class="grid">

        <!-- Upload Section -->
        <div class="col-12">
            <div class="surface-0 border-round p-3 mb-3">
                <h5 class="mt-0 mb-2">Dateien hochladen</h5>
                <p class="text-600 text-sm mt-0 mb-3">
                    Laden Sie hier Kontoauszugsdateien hoch (CAMT-XML oder Excel).
                    Wählen Sie den passenden Dokumenttyp aus der Liste.
                </p>

                @if (noConfiguredType) {
                    <p-message
                            severity="warn"
                            styleClass="w-full mb-3"
                            text="Für diesen Kreditor ist kein CAMT-Import-Dokumenttyp konfiguriert — hochgeladene Dateien werden nicht automatisch importiert.">
                    </p-message>
                }

                @if (configTypesLoaded) {
                    <mvs-dm-upload
                            [objectIdentifier]="objectIdentifier"
                            [documentTypeId]="defaultDocumentTypeId"
                            [allowedDocumentTypeIds]="allowedDocumentTypeIds"
                            [isDocumentTypeSelectionMode]="documentTypeSelectionMode"
                            [showDocumentTypeDropdown]="showDocumentTypeDropdown"
                            [accept]="uploadAccept"
                    ></mvs-dm-upload>
                } @else {
                    <div class="flex align-items-center gap-2 text-600 text-sm py-3">
                        <i class="fa-regular fa-spinner fa-spin"></i>
                        <span>Dokumenttypen werden geladen …</span>
                    </div>
                }
            </div>
        </div>

        <div class="col-12">
            <mvs-dm-object-documents
                    [objectIdentifier]="objectIdentifier"
            ></mvs-dm-object-documents>
        </div>
    </div>

}
